'use client'

import { useState } from 'react'

import { Button, ButtonTitle, ButtonIcon } from '@systhemaui/react'

import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faPlay } from '@fortawesome/free-solid-svg-icons'

function constructFaSvg(icon: IconDefinition) {
  if (!icon || !icon.icon || !icon.icon[0] || !icon.icon[1] || !icon.icon[4]) {
    return ''
  }

  const viewBox = `${icon.icon[0]} ${icon.icon[1]}`
  const path = icon.icon[4]

  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${viewBox}"><path fill="currentColor" d="${path}"/></svg>`
}

import Modal from './Modal'
import { Figure, MediaWrapper } from '@systhemaui/react'
import * as NextThirdParties from '@next/third-parties/google'
const { YouTubeEmbed } = NextThirdParties

export default function TrailerButton() {
  const [openIndex, setOpenIndex] = useState(false)
  return (
    <div>
      <Button type="button" variant="primary" onClick={() => setOpenIndex(true)}>
        <ButtonTitle className="max-md:text-left">Watch trailer</ButtonTitle>
        <ButtonIcon dangerouslySetInnerHTML={{ __html: constructFaSvg(faPlay) }} />
      </Button>
      <Modal open={openIndex} onClose={() => setOpenIndex(false)} size="lg" contentType="video">
        <Figure id="trailer" aria-label="Trailer" width="default">
          <MediaWrapper aspectRatio="16/9">
            <YouTubeEmbed videoid="H0eYXqiuyrQ" playlabel="Play Trailer" />
          </MediaWrapper>
        </Figure>
      </Modal>
    </div>
  )
}
